var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9701 10.9421C20.9701 10.1834 20.902 9.45396 20.7755 8.75366H10.699V12.8922H16.457C16.209 14.2296 15.4552 15.3627 14.3221 16.1214V18.8059H17.7798C19.8029 16.9433 20.9701 14.2004 20.9701 10.9421Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.699 21.3979C13.5878 21.3979 16.0096 20.4398 17.7798 18.8058L14.3221 16.1213C13.3641 16.7633 12.1385 17.1426 10.699 17.1426C7.91242 17.1426 5.55378 15.2605 4.71244 12.7317H1.138V15.5037C2.89848 19.0003 6.51669 21.3979 10.699 21.3979Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.71243 12.7319C4.49845 12.09 4.37687 11.4043 4.37687 10.6991C4.37687 9.99396 4.49845 9.30825 4.71243 8.66631V5.89429H1.13799C0.413371 7.33865 0 8.97269 0 10.6991C0 12.4256 0.413371 14.0596 1.13799 15.504L4.71243 12.7319Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.699 4.25529C12.2698 4.25529 13.6802 4.7951 14.789 5.85528L17.8576 2.78661C16.0048 1.06018 13.5829 0 10.699 0C6.51669 0 2.89848 2.39755 1.138 5.89419L4.71244 8.6662C5.55378 6.13735 7.91242 4.25529 10.699 4.25529Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.5b8cd2acc4b1968aecbeb6eb148e2f0f.svg";
export { ForwardRef as ReactComponent };